import React from 'react'
import Helmet from 'react-helmet'
import "./notification.scss"
import Loading from '../../../components/loading/loading'
import dayjs from 'dayjs'
import { Query, Mutation } from "react-apollo"
import { NotificationUser, ReadNotification } from "../../../queries/notification"

export default class Notifications extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            activePage: 1,
            total: 0,
            perfil: {},
            UserHash: {},
            pageNumber: 0,
            loading: true,
            skip: 0,
            notifications: {},
            listComplete: {},
        }

        
    }

    // nextPage = (pageNumber) => {
    //     this.setState({ loading: true })
    //     axios.get(`${config.API_URL}/notifications?userHash=${this.state.UserHash}&$skip=${(pageNumber - 1) * 10}&$sort=-createdAt`, {
    //         headers: { Authorization: this.state.accessToken }
    //       }).then(({ data: notes }) => {
    //         this.setState({
    //             notifications: notes.data,
    //             activePage: pageNumber,
    //             loading: false,
    //         })
    //     }).catch(err => console.log(err))
    // }

    render() {
        const cache = JSON.parse(sessionStorage.getItem('OITO'))
        if (cache) {
            this.playerId = cache.user.id
        } else {
            if (!this.state.showAlert) this.setState({
                showAlert: true,
                typeAlert: 'error',
                titleAlert: 'Você não está logado!',
                messageAlert: 'Entre ou cadastre-se. É gratuito!',
                onClose: () => window.location.href = '/login'
            })
            window.setTimeout(window.location.href = '/login', 2000)
        }

        this.readNotification = (id, link, ReadNotification) => {
            ReadNotification({
                variables:{
                    id
                }
            }).then (
                res => {
                    // console.log(res)
                    window.location.href = link
                }
            )
        }

        return (
            <div className="col-xs-12" style={{ maxWidth: '680px' }}>
                <Helmet>
                    <title>Oito - Notificações</title>
                    <meta name="description" content="Confira e administre as notificações referentes às negociações e oportunidades em Oito.app."/>
                    <meta name="keywords" content="Notificações, Profissionais, Oportunidades"/>
                    <meta name="robots" content="index, follow"/>
                    <meta httpEquiv="Content-Type" content="text/html; charset=utf-8"/>
                    <meta name="language" content="Portuguese"/>
                    <meta name="revisit-after" content="1 days"/>
                </Helmet>
                <div className='notificationList row center-xs'>
                    <div className="col-xs-12">
                        <h1 className="title-list">Notificações</h1>
                    </div>
                    
                    <section className="notification-list col-xs-12 row">
                        <Query query={NotificationUser} variables={{ id: this.playerId }}>
                            {result => {
                                if (result.loading) return <Loading />
                                if (result.error) return <p>{result.error.message}</p>
                                const notification = result.data.user.notifications
                                return (
                                    notification.length ?
                                        notification.map((n, i) =>
                                            <Mutation mutation={ReadNotification} key={i}>
                                                {(ReadNotification, { loading, error }) => {
                                                    if (loading) return <Loading />
                                                    if (error) return console.log(error)
                                                    return  <div onClick={() => this.readNotification(n.id, n.link, ReadNotification)} className={n.status ? "notification-card col-xs-12" : "notification-card col-xs-12 read"}>
                                                        <h3>{n.title}</h3>
                                                        <p>{n.description}</p>
                                                        <div><span>{dayjs(n.createdAt).format("DD/MM/YYYY")}</span></div>
                                                    </div>
                                                }}
                                            </Mutation>
                                        ) :
                                        <article className="msg-not-found"><h5>Você ainda não tem nenhuma notificação.</h5></article>
                                )
                            }}
                        </Query>
                    </section>
                </div>
            </div>
        )
    }
}
